import { AvatarSkeleton, TextSkeleton } from '@/components/Skeleton';

export const ScoreSectionLoader = () => (
  <div className="w-full relative p-6 h-[300px]">
    <TextSkeleton className="mb-[35px]" width={140} height={24} />

    <div className="flex items-center justify-center gap-[120px] h-[calc(100%-80px)]">
      <div className="flex flex-col items-center flex-[0_0_200px] pl-[50px]">
        <div className="h-20 mb-10 relative overflow-hidden w-[160px]">
          <AvatarSkeleton className="absolute top-0 left-0" size={160} />
          <div className="absolute left-0 h-20 z-1 -bottom-[80px] w-[160px] bg-special-background-app" />
        </div>

        <TextSkeleton className="mb-[5px]" width={80} height={20} />
        <TextSkeleton width={160} height={20} />
      </div>

      <div className="flex-1 max-w-[300px]">
        <TextSkeleton width="100%" height={200} />
      </div>
    </div>
  </div>
);
